<template>
  <div class="carrot">
    <div class="main-wrapper">
      <Menu></Menu>
      <div class="page-wrapper">
        <div class="page-content ">
          <div class="row">
            <div class="col-xl-12">
              <h3 class="page-title">픽포유 관리</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="clear mb-2">
                    <div class="form-group float-left clear w-100per">
                      <span style="font-weight: bold; cursor: pointer; font-size: 20px" @click="$router.push('/pick4u')">채널 리스트</span>
                      <span> | </span>
                      <span style="cursor: pointer; font-size: 20px" @click="$router.push('/pick4uVideo')">영상 리스트</span>
                    </div>
                    <div class="form-group float-left clear w-100per">
                      <table class="table table-bordered">
                        <tr>
                          <th>채널 ID</th>
                          <td>{{ channel.channel_id }}</td>
                        </tr>
                        <tr>
                          <th>채널 이름</th>
                          <td>{{ channel.channel_title }}</td>
                        </tr>
                        <tr>
                          <th>수집 영상 개수</th>
                          <td>{{ channel.count_video }}</td>
                        </tr>
                        <tr>
                          <th>등록 날짜</th>
                          <td>{{ channel.create_date }}</td>
                        </tr>
                        <tr>
                          <th>최근 수집일</th>
                          <td>{{ channel.current_create_date }}</td>
                        </tr>
                      </table>
                    </div>
                    <div>
                      <button class="btn btn-primary fl ml-10" @click="goPick4u()">목록</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="mb-2">수집 영상 리스트</h4>
                  <div class="table-responsive text-center" style="overflow-y: hidden;">
                    <table class="table table-bordered">
                      <tbody>
                      <tr align="center" height="25">
                        <th width="50" class="table02">No</th>
                        <th width="100" class="table02">영상 ID</th>
                        <th>영상 제목</th>
                        <th width="100" class="table02">수집일</th>
                        <th @click="deleteVideo()">삭제</th>
                      </tr>

                      <tr v-for="(channel, index) in this.videoList" align="center" height="25">
                        <td>{{ (result.total - (result.currentPage - 1) * result.perPage  ) - index }}</td>
                        <td>{{ channel.video_id }}</td>
                        <td><a :href="'https://www.youtube.com/watch?v=' + channel.video_id" target="_blank">{{ channel.title }}</a></td>
                        <td>{{ channel.createdate }}</td>
                        <td><button @click="deleteVideo(channel.video_id)">삭제</button></td>
                      </tr>
                      <tr v-if="this.videoList.length <= 0" >
                        <td colspan="10">
                          검색결과가 존재하지 않습니다.
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="this.videoList.length !== 0" style="padding-left:40%; padding-top:20px;">
                    <paginate :page-count="lastpage" :page-range="3" :margin-pages="2"
                              :click-handler="clickCallback" :prev-text="'Prev'"
                              :next-text="'Next'" :container-class="'pagination'"
                              :page-class="'page-link'">
                    </paginate>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '../../components/commons/incMenu'
import Paginate from 'vuejs-paginate';

export default {
  name: 'Pick4u',
  components: {
    Menu,
    Paginate
  },
  data () {
    return {
      lastpage: 0,
      channel: {},
      videoList: [],
      reuterTables: [],
      sendInfo: [],
      tutors: [],
      videos: [],
      filter: {
        receiveFl: '',
        sdate: '',
        edate: '',
        sField: 'R_NAME',
        sText: '',
      },
      years: [],
      months: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
      ]
    }
  },
  mounted () {
    this.selectChannels()
  },
  methods: {
    clickCallback: function (page) {
      this.filter.page = page
      this.selectChannels()
    },
    deleteVideo: function (videoId) {
      if(confirm('삭제 하시겠습니까?')){
        const url = '/v1/api/admin/pick4u/videos/' + videoId
        this.axios.delete(url)
        .then(res => {
          if (res.data.err === 0) {
            this.selectChannels()
          } else {
            alert('삭제에 실패했습니다.')
          }
        }).catch(err => {
          if (err.response.data.path === '/login/msg') {
            alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
            this.$router.push('/login')
          } else {
            alert('관리자에게 문의하세요')
          }
        })
      }
    },
    selectChannels: function () {
      const url = '/v1/api/admin/pick4u/channels/' + this.$route.params.id
      const params = this.getParams({
        sdate: this.filter.sdate
        , edate: this.filter.edate
        , channelName: this.filter.channelName
        , channelId: this.filter.channelId
        , page: this.filter.page
      })
      this.axios.get(url, {
        params: params
      })
      .then(res => {
        if (res.data.err === 0) {
          console.log(res)
          this.result = res.data.videoList
          this.channel = res.data.channel
          this.videoList = res.data.videoList.value
          this.lastpage = res.data.videoList.lastPage
        }
      }).catch(err => {
        if (err.response.data.path === '/login/msg') {
          alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
          this.$router.push('/login')
        } else {
          alert('관리자에게 문의하세요')
        }
      })
    },
    goPick4u: function () {
      window.history.back()
    },
  }
}
</script>

<style>
@import "../../../src/assets/scss/style.css";
@import "../../../src/assets/scss/commons/_style.css";
@import "../../../src/assets/scss/commons/_carrot.css";
</style>



// WEBPACK FOOTER //
// src/pages/p4u/pick4uDetail.vue